<template>

    <div class="container-center" v-loading.fullscreen.lock="fullscreenLoading">

        <el-card class="box-card">

            <div slot="header" class="clearfix contract-data-top with-icon">
                <img alt="img"
                     src="data:image/png;base64,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">
                <p><span class="title">{{ '履约保证金退还' +  (pageType == 0 ? '发起' : '详情') }}</span></p>
                <p class="status">
                    <span :title="detailData.approveStatus" v-bind:class="['state-shet'+ detailData.approveStatus]">
                        {{ baseStatus[detailData.approveStatus] }}
                    </span>
                </p>
                <br>所属合同：{{ decodeURIComponent($route.params.name) }} &nbsp;&nbsp;&nbsp;&nbsp; <span v-if="pageType!=0">发起时间：{{ detailData.createDate }}</span>
            </div>


            <!-- 履约担保记录 -->

            <div v-if="pageType==0" style="padding-top:20px;">
               <el-form label-width="160px" ref="form" :model="form" :rules="rules" size="mini">
                    <el-row>
                        <el-col :span="18" :offset="3">
                            
                            <el-form-item label="备注：" prop="remark">
                                <el-input type="textarea" v-model="form.remark" :rows="4" :maxlength="255"></el-input>
                            </el-form-item>

                            <el-form-item label="银行信息：">
                                 <div>
                                <el-table :data="bankInfo" border strip >
                                    <el-table-column width="55" label="单选">
                                        <template scope="scope">
                                            <el-radio :label="scope.row.id" v-model="choosedBankId" @change.native="changeChoosedBank(scope.$index, scope.row)">&nbsp;</el-radio>
                                        </template>
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="address"
                                        label="银行所在市">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="accountName"
                                        label="银行开户行名">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="relationNo"
                                        label="银行关联行号">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="name"
                                        label="开户行全称">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="bankNo"
                                        label="银行账号">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center" label="认证状态">
                                        <template slot-scope="scope">
                                            {{ scope.row.status == '2' ? '已认证' : '未认证' }}
                                        </template>
                                    </el-table-column>       
                                </el-table>
                                 </div>
                            </el-form-item>

                            <el-form-item label="上传附件：">
                                <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    :before-upload="beforeUpload"
                                    :on-remove="handleRemove"
                                    :action="uploadApi"
                                    :on-success="handleAdd"
                                    :on-error="uploadError"
                                    multiple
                                    :limit="6"
                                    :file-list="form.baseFiles">
                                    <el-button size="small" type="primary">上 传</el-button>
                                    <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                        <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <!-- 详情 -->
            <div v-if="pageType!=0" class="detail-box">
                <label class="fade-title">申请信息</label>
                <el-row>
                    <el-col :span="5" class="text-right">所选银行名称：</el-col>
                    <el-col :span="19">{{ detailData.bankName }} </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">所选银行帐号：</el-col>
                    <el-col :span="19">{{ detailData.bankNo }} </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">所选账户名称：</el-col>
                    <el-col :span="19">{{ detailData.accountName }} </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">备注：</el-col>
                    <el-col :span="19">{{ detailData.remark || '无' }} </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">附件：</el-col>
                    <el-col :span="19">
                        <div
                            v-if="!detailData.baseFiles || detailData.baseFiles && detailData.baseFiles.length==0"
                            class="no-data-tip"></div>
                        <ul v-else>
                            <li v-for="li in detailData.baseFiles" :key="li.id"><a
                                :href="downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName }}</a></li>
                        </ul>
                    </el-col>
                </el-row>
            </div>


            <el-row>
                <el-col :span="12" :offset="6">
                    <div class="text-center" style="padding:30px 0;">
                        <el-button @click="$router.push($root.navs[1].path)" type="" size="medium" icon="el-icon-back">
                            返回合同台账
                        </el-button>
                        <el-button v-if="pageType==0" @click="submit" :disabled="fullscreenLoading" type="primary" size="medium">提交申请
                        </el-button>
                    </div>
                </el-col>
            </el-row>


            <!-- 分隔线 -->
            <div v-if="pageType!=0" class="fade-line"></div>


            <!-- 审批记录 -->
            <div v-if="pageType!=0">
                <label class="fade-title">审批记录</label>

                <el-table :data="detailData.approveList||[]" size="mini" border stripe>
                    <el-table-column align="center" width="50" type="index" label="序号"></el-table-column>
                    <el-table-column align="center" width="160" label="发起时间" prop="createDate"></el-table-column>
                    <el-table-column align="center" width="160" label="审批结果" prop="approveStatus">
                        <template slot-scope="scope">
                            <span v-bind:class="'state-shet'+scope.row.approveStatus" :title="scope.row.approveStatus">
                                {{ baseStatus[scope.row.approveStatus] }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="审批意见" prop="approveRemark"></el-table-column>
                    <el-table-column align="center" width="160" label="审批时间" prop="approveDate"></el-table-column>
                </el-table>
            </div>
        </el-card>


    </div><!-- container-center -->

</template>

<script>
    import banner from '@/assets/imgs/banner_inviteMng.png'
    import util from '@/util'

    export default {
        name: 'peChange-detail',
        data() {
            return {
                supplierId: this.$root.stockId,
                uploadApi: `${util.baseUrl}rest/file/upload`,
                downloadApi: `${util.baseUrl}rest/file/down`,

                baseStatus: [
                    '申请审批中',
                    '申请打回',
                    '申请不通过',
                    '申请通过'
                ],

                // 页面类型 0: 发起,带billId;  1: 查看,带msgId
                pageType: this.$route.params.type,

                // 详情数据
                detailData: {},

                // 表单
                form: {
                    baseFiles: [],
                    remark: '',
                    bankId: '',
                    bankName: '',
                    bankNo: '',
                    accountName: ''
                },
                rules: {
                },
                nowType: this.$route.params.nowType,
                fullscreenLoading: false,
                bankInfo: [],
                choosedBankId: '',
                choosedBankInfo: {},
            }
        },
        methods: {

            // 上传文件格式验证
            beforeUpload(file) {

                if (file.size / 1024 / 1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M', '文件过大！', {type: 'error'})
                    return false
                }

                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },

            uploadError() {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'});
            },
            changeChoosedBank(index, val) {
                this.choosedBankId = val.id
                this.choosedBankInfo = val
            },
            // 提交
            submit() {
                this.fullscreenLoading = true
                this.$refs['form'].validate((valid) => {
                    if (valid) {

                        if (!this.choosedBankId) {
                            this.$message.error('请选择银行信息');
                            this.fullscreenLoading = false
                            return 
                         }

                         this.form.baseFiles =  __getBaseFiles__(null, this.$refs.upload.uploadFiles)

                        if (this.pageType == 0) {  // 发起
                            this.form.contractBillId = this.$route.params.id
                            // 设置发起质保金退还申请的银行信息
                            this.form.bankId = this.choosedBankId
                            this.form.bankName = this.choosedBankInfo.name
                            this.form.bankNo = this.choosedBankInfo.bankNo
                            this.form.accountName = this.choosedBankInfo.accountName
                            

                            this.$http.post('rest/api/dsp/peChange/addBondBack',
                                Object.assign({}, this.form)
                            ).then((res) => {
                                if (res.data.result) {
                                    this.$message({message: '提交成功', type: 'success'})

                                    // 提交后跳转
                                    this.$router.push(`/ContractDetail13/1/${res.data.value.id}/${encodeURIComponent(this.$route.params.name)}`)
                                    setTimeout(function () {
                                        location.reload()
                                    }, 1000)

                                } else {
                                    this.fullscreenLoading = false
                                    this.$message({message: ('Error: 提交失败' + res.data.message), type: 'error'})
                                }
                            })
                        }
                    } else {
                        this.$message({message: '履约保证金退还申请参数未填写规范', type: 'error'})
                        this.fullscreenLoading = false
                        return false;
                    }
                });
            },
            // 获取详情
            getDetailData() {
                this.fullscreenLoading = true
                this.$http.get(`rest/api/dsp/peChange/getBackInfo/${this.$route.params.id}`).then((res) => {
                    this.fullscreenLoading = false
                    if (res.data.result) {
                        this.detailData = res.data.value;
                        
                        this.detailData.baseFiles.forEach(function (data) {
                            data.name = data.fileOldName
                        })

                        let tempApprove = {}
                        tempApprove.createDate = this.detailData.createDate
                        tempApprove.approveDate = this.detailData.approveDate
                        tempApprove.approveStatus = this.detailData.approveStatus
                        tempApprove.approveRemark = this.detailData.approveRemark

                        this.detailData.approveList = [tempApprove]

                        this.$root.navs = [{
                            name: '合同业务列表',
                            path: '/contractList'
                        }, {
                            name: decodeURIComponent(this.$route.params.name),
                            path: '/contractSheet/' + encodeURIComponent(this.detailData.contractBillId)
                        }, {name: '详情'}]

                    } else {
                        this.$message({message: 'Error: 获取详情', type: 'error'})
                    }
                })
            },

            handleRemove (file, fileList) {
                // this.form.baseFiles = this.form.baseFiles.filter(function (f) {
                //     return f.uid !== file.uid
                // });
            },
            handleAdd (response, file, fileList) {
                // if(file.status=='success'){
                // this.form.baseFiles = __getBaseFiles__(file, fileList)
                // }
            },
            getBankInfoList () {
                this.$http.post('rest/api/completeFourInfo/getBankInfo', {
                    
                    stockId: this.supplierId
                }).then((res) => {
                    if (res.data.result) {
                        this.bankInfo = res.data.value;
                        
                        // 如果第一个是已认证的直接选择
                        if (this.bankInfo.length > 0 && this.bankInfo[0].status == '2') {
                            this.choosedBankId = this.bankInfo[0].id
                            this.choosedBankInfo = this.bankInfo[0]
                        }
                    }
                })
            },
        },
        created() {
            this.$root.headImage.src = banner
            this.$root.activeIndex = 'home'
            this.$root.isPublic = false
            this.$root.navs = []

        },
        mounted() {

            // dev test
            window.ji = this;

            if (this.pageType == 0) {
                this.$root.navs = [{
                    name: '合同业务列表',
                    path: '/contractList'
                }, {
                    name: decodeURIComponent(this.$route.params.name),
                    path: '/contractSheet/' + encodeURIComponent(this.$route.params.id)
                }, {name: '发起'}]
            } else {
                this.getDetailData()
            }

            util.toTop();

            if (this.pageType == 0) {
                this.getBankInfoList()
            }
        }
    }

    function __getBaseFiles__(file, fileList) {
        let fs = [];
        fileList.forEach(function (item) {
            console.log(item)
            if (item.response) {
                let f = item.response.basefiles[0];
                item.bizTableName = f.biztablename;
                item.bizTablePkName = f.biztablepkname;
                item.bizTablePkValue = f.biztablepkvalue;
                item.fid = f.fid;
                item.fileCatagoryId = f.filecatagoryid;
                item.fileDesc = f.filedesc;
                item.fileOldName = f.fileoldname;
                item.name = f.fileoldname;
                item.fileName = f.filename;
                item.filePath = f.filepath;
                item.fileSize = f.filesize;
                item.fileType = f.filetype;
                item.sort = f.sort;
            }
            fs.push(item);
        });
        console.log(fs);
        return fs
    }

</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';
    a {
        color: var(--cMain);
        cursor: pointer;
    }

    ul {
        padding: 0;
        margin: 0;
    }

    ul li {
        list-style: none;
    }

    .box-card {
        margin: 30px 0;
    }


    .fade-title {
        display: inline-block;
        margin-bottom: 20px;
        color: var(--cTxt2);
        font-size: 15px;
        font-weight: bold;
        line-height: 28px;
    }

    .fade-line {
        border-top: 1px dashed #ddd;
        margin: 40px 0;
    }


    .detail-box {
        padding: 20px 120px;
    }

    .detail-box .el-row {
        line-height: 48px;
    }

    .detail-box .text-right {
        color: var(--cTxt3);
    }


</style>



// WEBPACK FOOTER //
// src/pages/dsp/contract/vDetail13.vue